var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("EditSelect", {
    staticClass: "document-status-eip",
    attrs: { items: _vm.formattedSteps, canEdit: _vm.canEdit, showTag: true },
    on: { update: _vm.handleStatusUpdate }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }